import { RootState } from 'src/redux/reducers/rootReducer';

export const getFetchMultiApprovalSelector = (state: RootState) =>
  state.multiApproval.fetch;

export const getFetchChildMultiApprovalSelector = (state: RootState) =>
  state.multiApproval.fetchChild;

export const getSubmitMultiApprovalSelector = (state: RootState) =>
  state.multiApproval.submit;

export const getChildSubmitMultiApprovalSelector = (state: RootState) =>
  state.multiApproval.childSubmit;

export const getFetchActiveMultiApprovalSelector = (state: RootState) =>
  state.multiApproval.activeRule;

export const getFetchIsParentActiveMultiApprovalSelector = (state: RootState) =>
  state.multiApproval.parentActive;
